import React from "react";
import PropTypes from "prop-types";
import DocumentScoringHistoryContainer from "features/document/edit/scoringHistory/components/DocumentScoringHistoryContainer";

const FolderScoringHistoryContainer = ({ documentId, siteId, history }) => {
  const onOpenScoringSessionHistory = (documentId, siteId, sessionID) => () => {
    history.push(`/folders/${documentId}/${siteId}/${sessionID}/historyscoringsession`);
  };

  return (
    <DocumentScoringHistoryContainer
      documentId={documentId}
      siteId={siteId}
      onOpenScoringSessionHistory={onOpenScoringSessionHistory}
    />
  );
};

FolderScoringHistoryContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  history: PropTypes.object.isRequired
};

export default FolderScoringHistoryContainer;
